<template>
  <el-container class="login_bg" type="flex" style="height:100%">
  <el-main>
    <div class="main_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="(item, index) in indexPath" :key="index">{{ item.split('-')[1] }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button class="yellow_btn" size="mini" icon="el-icon-plus"
        @click="dialogVisible = true; isAdd = true; getProvinceList()">
        新增地址</el-button>
    </div>
    <el-card v-for="item in tableData" :key="item.id">
      <h4 style="margin-top:0">
        {{ item.receivdFullName }} <span class="subtitle" v-if="item.isDefault == 1">默认地址</span>

      </h4>
      <el-divider></el-divider>
      <div class="info">
        <div>联系电话: {{ item.receivdTel }}</div>
        <div>收货地址：{{ item.revicedProvinceName + item.provinceCityName + item.provinceAreaName + item.receivdAddr }}
        </div>
        <div>邮编：{{ item.postalCode }}</div>
      </div>
      <div class="btns">
        <el-button size="small" type="danger" style="margin-right:10px" @click="handleDelete(item.id)">删除</el-button>
        <el-button size="small" class="yellow_btn" style="margin-right:10px" @click="handleEdit(item)">编辑</el-button>
        <el-button size="small" class="yellow_btn" v-if="item.isDefault == 0" @click="handleSetting(item)">设为默认
        </el-button>
      </div>
    </el-card>
    <!-- 添加-編輯窗口 -->
    <el-dialog :title="isAdd ? '新增' : '编辑'" :visible.sync="dialogVisible" width="60%" center :close-on-click-modal="false"
      :show-close="false">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="收货人" prop="receiveFullName" :rules="[
          { required: true, message: '请输入收货人', trigger: 'blur' }
        ]">
          <el-input v-model="editForm.receiveFullName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="receiveTel" :rules="[
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ]">
          <el-input v-model="editForm.receiveTel" placeholder="请输入"
            @input="formInline.receiveTel = formInline.user_name.replace(/^(0+)|[^\d]+/g, '')"></el-input>
        </el-form-item>
        <el-form-item label="收货地址" prop="area" :rules="[
          { required: true, message: '请选择收货地址', trigger: 'blur' }
        ]">
          <el-row>
            <el-col :span="8">
              <el-select v-model="editForm.province" filterable placeholder="省" @change="handleChangeProvince">
                <el-option v-for="item in provinceList" :key="item.proId" :label="item.proName"
                  :value="item.proId + '&' + item.proName">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="editForm.city" filterable placeholder="市" @change="handleChangeCity">
                <el-option v-for="item in cityList" :key="item.cityId" :label="item.cityName"
                  :value="item.cityId + '&' + item.cityName">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="8">
              <el-select v-model="editForm.area" filterable placeholder="区" @change="handleChangeArea">
                <el-option v-for="item in areaList" :key="item.countyId" :label="item.countyName"
                  :value="item.countyId + '&' + item.countyName">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="详细地址" prop="receiveAddr" :rules="[
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ]">
          <el-input type="textarea" v-model="editForm.receiveAddr" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="postalCode">
          <el-input v-model="editForm.postalCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="设置默认">
          <el-checkbox v-model="editForm.isDefault"></el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="beforeClose('editForm')">取 消</el-button>
        <el-button type="primary" :disabled="btnDisabled" @click="submitForm('editForm')">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>

  <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getMailList,
  getProvinceList,
  getCityList,
  getAreaList,
  addMail,
  editMail,
  delMail
} from '@/api.js'
import {
  mapState
} from 'vuex'

export default {
  name: "SystemRole",
  data() {
    return {
      isAdd: true,
      tableData: [],
      formInline: {
        page: 1,
        size: 10
      },
      total: 0,
      btnDisabled: false,
      list: [],
      dialogVisible: false,
      editForm: {
        province: '',
        city: '',
        area: '',
        receiveFullName: '',
        receiveTel: '',
        receiveProvinceCode: '',
        receiveCityCode: '',
        receiveAreaCode: '',
        receiveProvinceName: '',
        receiveCityName: '',
        receiveAreaName: '',
        receiveAddr: '',
        postalCode: '',
        isDefault: ''
      },
      provinceList: [],
      cityList: [],
      areaList: [],
    }
  },
  created() {
    this.getTableDate()
  },
  mounted() { },
  methods: {
    //获取表格数据
    getTableDate() {
      getMailList(this.formInline).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getProvinceList() {
      getProvinceList().then(res => {
        if (res.code == 0) {
          this.provinceList = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getCityList(id) {
      getCityList({
        proId: id
      }).then(res => {
        if (res.code == 0) {
          this.cityList = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getAreaList(id) {
      getAreaList({
        proId: this.editForm.receiveProvinceCode,
        cityId: id
      }).then(res => {
        if (res.code == 0) {
          this.areaList = res.data.list
        } else {
          this.$message.error(res.message)
        }
      })
    },
    handleChangeProvince(val) {
      const province = val.split('&')
      this.getCityList(province[0])
      this.editForm.receiveProvinceCode = province[0]
      this.editForm.receiveProvinceName = province[1]
      this.editForm.receiveCityCode = ''
      this.editForm.receiveCityName = ''
      this.editForm.city = ''
      this.editForm.receiveAreaCode = ''
      this.editForm.receiveAreaName = ''
      this.editForm.area = ''
    },
    handleChangeCity(val) {
      const city = val.split('&')
      this.getAreaList(city[0])
      this.editForm.receiveCityCode = city[0]
      this.editForm.receiveCityName = city[1]
      this.editForm.receiveAreaCode = ''
      this.editForm.receiveAreaName = ''
      this.editForm.area = ''
    },
    handleChangeArea(val) {
      const Area = val.split('&')
      this.editForm.receiveAreaCode = Area[0]
      this.editForm.receiveAreaName = Area[1]
    },
    //表格查询
    onSearch() {
      this.formInline.page = 1
      this.getTableDate();
    },
    handleCurrentChange(val) {
      this.formInline.page = val
      this.getTableDate();
    },
    handleSizeChange(val) {
      this.formInline.page = 1
      this.formInline.pageSize = val
      this.getTableDate();
    },
    //表格的操作
    //编辑
    handleEdit(row) {

      this.isAdd = false
      this.editForm.id = row.id
      this.editForm.receiveTel = row.receivdTel
      this.editForm.receiveFullName = row.receivdFullName
      this.editForm.receiveProvinceCode = row.revicedProvinceCode
      this.editForm.receiveCityCode = row.revicedCityCode
      this.editForm.receiveAreaCode = row.revicedAreaCode
      this.editForm.receiveProvinceName = row.revicedProvinceName
      this.editForm.receiveCityName = row.provinceCityName
      this.editForm.receiveAreaName = row.provinceAreaName
      this.editForm.receiveAddr = row.receivdAddr
      this.editForm.postalCode = row.postalCode
      this.editForm.province = row.revicedProvinceCode + '&' + row.revicedProvinceName
      this.editForm.city = row.revicedCityCode + '&' + row.provinceCityName
      this.editForm.area = row.revicedAreaCode + '&' + row.provinceAreaName
      this.editForm.isDefault = row.isDefault == 0 ? false : true

      this.getProvinceList()
      this.getCityList(row.revicedProvinceCode)
      this.getAreaList(row.revicedCityCode)

      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnDisabled = true
          this.editForm.isDefault = this.editForm.isDefault ? 1 : 0
          if (this.isAdd) {
            addMail(this.editForm).then(res => {
              this.btnDisabled = false;
              if (res.code == 0) {
                this.beforeClose(formName)
                this.$message.success(res.message);
                this.getTableDate();
              } else {
                this.$message.error(res.message)
              }
            })
          } else {
            editMail(this.editForm).then(res => {
              this.btnDisabled = false;
              if (res.code == 0) {
                this.beforeClose(formName)
                this.$message.success(res.message);
                this.getTableDate();
              } else {
                this.$message.error(res.message)
              }
            })
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //设为默认
    handleSetting(row) {
      this.$confirm('此操作將该地址设为默认邮寄地址, 是否继续？', '提 示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        center: true
      }).then(() => {
        row.isDefault = 1
        editMail(row).then(res => {
          this.btnDisabled = false;
          if (res.code == 0) {
            this.$message.success(res.message);
            this.getTableDate();
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {

      });
    },
    //删除
    handleDelete(id) {
      this.$confirm('此操作將刪除该地址, 是否继续？', '提 示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        center: true
      }).then(() => {
        delMail({
          id: id
        }).then(res => {
          if (res.code == 0) {
            this.$message.success(res.message);
            this.getTableDate();
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch(() => {

      });
    },
    beforeClose(formName) {
      this.dialogVisible = false
      this.$refs[formName].resetFields()
      this.editForm = {
        province: '',
        city: '',
        area: '',
        receiveFullName: '',
        receiveTel: '',
        receiveProvinceCode: '',
        receiveCityCode: '',
        receiveAreaCode: '',
        receiveProvinceName: '',
        receiveCityName: '',
        receiveAreaName: '',
        receiveAddr: '',
        postalCode: '',
        isDefault: ''
      }
      this.provinceList = []
      this.cityList = []
      this.areaList = []
    }
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath
    }),
  },
}
</script>

<style scoped lang="scss">
.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
  }
}
.main_header {
  display: flex;
  justify-content: space-between;
}

.el-card {
  position: relative;
  width: 500px;
  height: 300px;
  margin-top: 10px;
  margin-right: 10px;
  display: inline-block;

  .btns{
    position:absolute;
    right: 20px;
    bottom: 20px;
  }

  .info {
    font-size: 14px;
  }

  .el-button {
    float: right;
  }

  .subtitle {
    float: right;
    font-size: 14px;
    color: #ffd04b;
  }
}
</style>